import React, {FC} from "react";
import {css, Theme} from "@emotion/react";

import {pointer} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";

const closeButton = (closeModal: (e: React.MouseEvent) => void) => <CloseIcon css={closeButtonStyle} size="2.2" onClick={closeModal} />;

export const RPModal: FC<IModalCore> = (props) => {
    return (
        <ModalCore className={props.className} {...props} overlayStyle={overlayStyle} shouldCloseOnOverlayClick closeButton={props.closeButton || closeButton}>
            {props.children}
        </ModalCore>
    );
};

const overlayStyle = {
    zIndex: 9000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const closeButtonStyle = css`
    ${pointer};
    position: absolute;
    top: 2rem;
    right: 2rem;
`;

// TODO: this atom MAY require a refactor, as it was developed for rp_old offer gallery in the first place and then reused in different places.
export const darkModalStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.secondary};

    .modal-close-icon {
        fill: white;
    }
`;
import React, {FC} from "react";
import {css, Theme} from "@emotion/react";

import {pointer} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {IModalCore, ModalCore} from "@pg-design/modal-module";

const closeButton = (closeModal: (e: React.MouseEvent) => void) => <CloseIcon css={closeButtonStyle} size="2.2" onClick={closeModal} />;

export const RPModal: FC<IModalCore> = (props) => {
    return (
        <ModalCore className={props.className} {...props} overlayStyle={overlayStyle} shouldCloseOnOverlayClick closeButton={props.closeButton || closeButton}>
            {props.children}
        </ModalCore>
    );
};

const overlayStyle = {
    zIndex: 9000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

const closeButtonStyle = css`
    ${pointer};
    position: absolute;
    top: 2rem;
    right: 2rem;
`;

// TODO: this atom MAY require a refactor, as it was developed for rp_old offer gallery in the first place and then reused in different places.
export const darkModalStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.secondary};

    .modal-close-icon {
        fill: white;
    }
`;
